import { render, staticRenderFns } from "./SelfEvaluationTable.vue?vue&type=template&id=3b59df12&scoped=true"
import script from "./SelfEvaluationTable.vue?vue&type=script&lang=js"
export * from "./SelfEvaluationTable.vue?vue&type=script&lang=js"
import style0 from "./SelfEvaluationTable.vue?vue&type=style&index=0&id=3b59df12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b59df12",
  null
  
)

export default component.exports